import { SPOT_GREY_2 } from '@thredup/styleguide/src/variables/colors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DEFAULT_CHART_PROPS: any = {
  animate: true,
  axisBottom: null,
  axisLeft: null,
  axisRight: null,
  axisTop: null,
  isInteractive: false,
  motionDamping: 15,
  motionStiffness: 90,
  padding: 0.25,
  theme: {
    axis: {
      ticks: {
        line: { stroke: SPOT_GREY_2, strokeWidth: 1 },
        text: {
          fontFamily: 'proxima-nova',
          fontSize: '14px'
        }
      }
    },
    grid: {
      line: {
        stroke: SPOT_GREY_2,
        strokeWidth: 1
      }
    },
    legends: {
      text: {
        fontFamily: 'proxima-nova',
        fontSize: '14px',
        textTransform: 'capitalize'
      }
    }
  }
};
